// src/utils/collegeImageMapper.js

/*
This file centralizes the mapping of college names to their corresponding
thumbnail and header images. This avoids hardcoding paths in multiple
components and makes it easy to update image assets in one place.
*/

// --- Thumbnail Images ---
// Sourced from public/TopCollegeProfileTHUMBNAILS/
const thumbnailMap = {
  'Harvard University': '/harvard.jpg',
  'Stanford University': '/TopCollegeProfileTHUMBNAILS/StanfordThumbnail.jpg',
  'Massachusetts Institute of Technology': '/mit_institution.jpg',
  'Princeton University': '/TopCollegeProfileTHUMBNAILS/PrincetonThumbnail.jpg',
  'Yale University': '/TopCollegeProfileTHUMBNAILS/YaleThumbnail.jpg',
  'University of Chicago': '/TopCollegeProfileTHUMBNAILS/UChicagoThumbnail.jpg',
  'University of Pennsylvania': '/TopCollegeProfileTHUMBNAILS/UPennThumbnail.jpg',
  'California Institute of Technology': '/TopCollegeProfileTHUMBNAILS/CaltechThumbnail.jpg',
  'Duke University': '/TopCollegeProfileTHUMBNAILS/DukeThumbnail.jpg',
  'Johns Hopkins University': '/TopCollegeProfileTHUMBNAILS/JohnsHopkinsThumbnail.jpg',
  'Northwestern University': '/TopCollegeProfileTHUMBNAILS/NorthwesternThumbnail.jpg',
  'Cornell University': '/TopCollegeProfileTHUMBNAILS/CornellThumbnail.jpg',
  'Brown University': '/TopCollegeProfileTHUMBNAILS/BrownThumbnail.jpg',
  'Columbia University': '/TopCollegeProfileTHUMBNAILS/ColumbiaThumbnail.jpg',
  'Dartmouth College': '/TopCollegeProfileTHUMBNAILS/DartmouthThumbnail.jpg',
  'Vanderbilt University': '/TopCollegeProfileTHUMBNAILS/VanderbuiltThumbnail.jpg',
  'Rice University': '/TopCollegeProfileTHUMBNAILS/RiceThumbnail.jpg',
  'University of California, Los Angeles': '/TopCollegeProfileTHUMBNAILS/UCLAThumbnail.jpg',
  'University of California, Berkeley': '/TopCollegeProfileTHUMBNAILS/UCBerkeleyThumbnail.jpg',
  'New York University': '/TopCollegeProfileTHUMBNAILS/NYUThumbnail.jpg',
  'University of Southern California': '/TopCollegeProfileTHUMBNAILS/USCThumbnail.jpg',
  'Carnegie Mellon University': '/TopCollegeProfileTHUMBNAILS/CMUThumbnail.jpg',
  'University of Notre Dame': '/TopCollegeProfileTHUMBNAILS/NotreDameThumbnail.jpg',
  'Georgetown University': '/TopCollegeProfileTHUMBNAILS/GeorgetownThumbnail.jpg',
  'Emory University': '/TopCollegeProfileTHUMBNAILS/EmoryThumbnail.jpg',
  'University of Michigan–Ann Arbor': '/TopCollegeProfileTHUMBNAILS/UMichThumbnail.jpg',
  'University of Virginia': '/TopCollegeProfileTHUMBNAILS/UVAThumbnail.jpg',
  'Wake Forest University': '/TopCollegeProfileTHUMBNAILS/WF_Thumbnail.jpg',
  'University of Florida': '/TopCollegeProfileTHUMBNAILS/UoFloridaThumbnail.jpg',
  'University of North Carolina–Chapel Hill': '/TopCollegeProfileTHUMBNAILS/UNCThumbnail.jpg',
  'Tufts University': '/TopCollegeProfileTHUMBNAILS/TuftsThumbnail.jpg',
  'University of California, Santa Barbara': '/TopCollegeProfileTHUMBNAILS/UCSBThumbnail.jpg',
  'University of California, San Diego': '/TopCollegeProfileTHUMBNAILS/UCSDThumbnail.jpg',
  'University of California, Irvine': '/TopCollegeProfileTHUMBNAILS/UCIrvineThumbnail.jpg',
  'University of California, Davis': '/TopCollegeProfileTHUMBNAILS/UCDavisThumbnail.jpg',
  'University of California, Santa Cruz': '/TopCollegeProfileTHUMBNAILS/UCSantaCruz_Thumbnail.jpg',
  'University of California, Merced': '/TopCollegeProfileTHUMBNAILS/UCMerced_Thumbnail.jpg',
  'University of California, Riverside': '/TopCollegeProfileTHUMBNAILS/UCRiverside_Thumbnail.jpg',
  'Boston College': '/TopCollegeProfileTHUMBNAILS/BostonCollegeThumbnail.jpg',
  'Boston University': '/TopCollegeProfileTHUMBNAILS/BostonUniversityThumbnail.jpg',
  'Georgia Institute of Technology': '/TopCollegeProfileTHUMBNAILS/GTechThumbnail.jpg',
  'University of Texas at Austin': '/TopCollegeProfileTHUMBNAILS/UTAustinThumbnail.jpg',
  'The University of Texas–Dallas': '/TopCollegeProfileTHUMBNAILS/UTDallas_Thumbnail.jpg',
  'University of Washington': '/TopCollegeProfileTHUMBNAILS/UW_Thumbnail.jpg',
  'University of Wisconsin-Madison': '/TopCollegeProfileTHUMBNAILS/UWMadison.jpg',
  'University of Illinois Urbana-Champaign': '/TopCollegeProfileTHUMBNAILS/UIUCThumbnail.jpg',
  'University of Illinois Chicago': '/TopCollegeProfileTHUMBNAILS/UIC_Thumbnail.jpg',
  'Ohio State University': '/TopCollegeProfileTHUMBNAILS/Ohio-State-UniversityTHUMBNAIL.jpg',
  'Purdue University': '/TopCollegeProfileTHUMBNAILS/PurdueThumbnail.jpg',
  'Texas A&M University': '/TopCollegeProfileTHUMBNAILS/TAMU_Thumbnail.jpg',
  'Rutgers University': '/TopCollegeProfileTHUMBNAILS/RutgersThumbnail.jpg',
  'Rutgers University–Newark': '/TopCollegeProfileTHUMBNAILS/RutgersNewark_Thumbnail.jpg',
  'University of Maryland': '/TopCollegeProfileTHUMBNAILS/UMDCollegeParkThumbnail.jpg',
  'University of Maryland, Baltimore County': '/TopCollegeProfileTHUMBNAILS/UniversityofMarylandBaltimore_Thumbnail.jpg',
  'University of Rochester': '/TopCollegeProfileTHUMBNAILS/URochesterThumbnail.jpg',
  'Case Western Reserve University': '/TopCollegeProfileTHUMBNAILS/CaseWesternThumbnail.jpg',
  'Lehigh University': '/TopCollegeProfileTHUMBNAILS/LehighThumbnail.jpg',
  'Virginia Tech': '/TopCollegeProfileTHUMBNAILS/VTech_Thumbnail.jpg',
  'Virginia Commonwealth University': '/TopCollegeProfileTHUMBNAILS/VirginiaCommonwealth_Thumbnail.jpg',
  'Washington University in St. Louis': '/TopCollegeProfileTHUMBNAILS/WashUThumbnail.jpg',
  'University of Georgia': '/TopCollegeProfileTHUMBNAILS/UGA_Thumbnail.jpg',
  'University of Miami': '/TopCollegeProfileTHUMBNAILS/UMiami_Thumbnail.jpg',
  'University of Massachusetts Amherst': '/TopCollegeProfileTHUMBNAILS/UMassAmherst_Thumbnail.jpg',
  'North Carolina State University': '/TopCollegeProfileTHUMBNAILS/NCSU_Thumbnail.jpg',
  'Michigan State University': '/TopCollegeProfileTHUMBNAILS/MichiganState_Thumbnail.jpg',
  'The Pennsylvania State University–University Park': '/TopCollegeProfileTHUMBNAILS/PennState_Thumbnail.jpg',
  'Stony Brook University (SUNY)': '/TopCollegeProfileTHUMBNAILS/StonyBrook_Thumbnail.jpg',
  'University at Buffalo (SUNY)': '/TopCollegeProfileTHUMBNAILS/SUNYBuffalo_Thumbnail.jpg',
  'University at Albany (SUNY)': '/TopCollegeProfileTHUMBNAILS/SUNYAlbany_Thumbnail.jpg',
  'Santa Clara University': '/TopCollegeProfileTHUMBNAILS/SantaClara_Thumbnail.jpg',
  'Tulane University of Louisiana': '/TopCollegeProfileTHUMBNAILS/Tulane_Thumbnail.jpg',
  'Villanova University': '/TopCollegeProfileTHUMBNAILS/Villanova_Thumbnail.jpg',
  'Brandeis University': '/TopCollegeProfileTHUMBNAILS/Brandheis_Thumbnail.jpg',
  'George Washington University': '/TopCollegeProfileTHUMBNAILS/GeorgeWashingtonU_Thumbnail.jpg',
  'San Diego State University': '/TopCollegeProfileTHUMBNAILS/SDState_Thumbnail.jpg',
  'University of Arizona': '/TopCollegeProfileTHUMBNAILS/UniversityofArizona_Thumbnail.jpg',
  'University of Missouri': '/TopCollegeProfileTHUMBNAILS/UniversityofMizzou_Thumbnail.jpg',
  'University of New Hampshire': '/TopCollegeProfileTHUMBNAILS/UniversityofNewHampshire_Thumbnail.jpg',
  'University of Oregon': '/TopCollegeProfileTHUMBNAILS/UniversityofOregon_Thumbnail.jpg',
  'Oregon State University': '/TopCollegeProfileTHUMBNAILS/OregonState_Thumbnail.jpg',
  'University of San Diego': '/TopCollegeProfileTHUMBNAILS/UniversityofSanDiego_Thumbnail.jpg',
  'University of San Francisco': '/TopCollegeProfileTHUMBNAILS/UniversityofSanFrancisco_Thumbnail.jpg',
  'University of Tennessee–Knoxville': '/TopCollegeProfileTHUMBNAILS/UniversityofTennesseeKnoxville_Thumbnail.jpg',
  'University of Delaware': '/TopCollegeProfileTHUMBNAILS/UniversityofDelaware_Thumbnail.jpg',
  'University of Denver': '/TopCollegeProfileTHUMBNAILS/UniversityofDenver_Thumbnail.jpg',
  'University of South Carolina': '/TopCollegeProfileTHUMBNAILS/UniversityofSouthCarolina_Thumbnail.jpg',
  'University of Vermont': '/TopCollegeProfileTHUMBNAILS/UniversityofVermont_Thumbnail.jpg',
  'University of Utah': '/TopCollegeProfileTHUMBNAILS/UniversityofUtah_Thumbnail.jpg',
  'University of Houston': '/TopCollegeProfileTHUMBNAILS/UniversityofHouston_Thumbnail.jpg',
  'The University of Oklahoma': '/TopCollegeProfileTHUMBNAILS/UniversityofOklahoma_Thumbnail.jpg',
  'University of Alabama at Birmingham': '/TopCollegeProfileTHUMBNAILS/AlabamaBirmigham_Thumbnail.jpg',
  'University of Dayton': '/TopCollegeProfileTHUMBNAILS/UniversityofDayton_Thumbnail.jpg',
  'University of the Pacific': '/TopCollegeProfileTHUMBNAILS/UniversityofthePacific_Thumbnail.jpg',
  'Drexel University': '/TopCollegeProfileTHUMBNAILS/Drexel_Thumbnail.jpg',
  'Rensselaer Polytechnic Institute': '/TopCollegeProfileTHUMBNAILS/Rensselaer_Thumbnail.jpg',
  'Stevens Institute of Technology': '/TopCollegeProfileTHUMBNAILS/Stevens_Thumbnail.jpg',
  'New Jersey Institute of Technology': '/TopCollegeProfileTHUMBNAILS/NJIT_Thumbnail.jpg',
  'University of Connecticut': '/TopCollegeProfileTHUMBNAILS/UConn_Thumbnail.jpg',
  'University of Pittsburgh': '/TopCollegeProfileTHUMBNAILS/UPitt_Thumbnail.jpg',
  'Binghamton University (SUNY)': '/TopCollegeProfileTHUMBNAILS/BinghamtonSUNY_Thumbnail.jpg',
  'Indiana University–Bloomington': '/TopCollegeProfileTHUMBNAILS/IUBloomington_Thumbnail.jpg',
  'Syracuse University': '/TopCollegeProfileTHUMBNAILS/SyracuseUniversity_Thumbnail.jpg',
  'Colorado School of Mines': '/TopCollegeProfileTHUMBNAILS/ColoradoSchoolofMines_Thumbnail.jpg',
  'Pepperdine University': '/TopCollegeProfileTHUMBNAILS/Pepperdine_Thumbnail.jpg',
  'Howard University': '/TopCollegeProfileTHUMBNAILS/Howard_Thumbnail.jpg',
  'Marquette University': '/TopCollegeProfileTHUMBNAILS/Marquette_Thumbnail.jpg',
  'Auburn University': '/TopCollegeProfileTHUMBNAILS/Auburn_Thumbnail.jpg',
  'Illinois Institute of Technology': '/TopCollegeProfileTHUMBNAILS/IllinoisIT_Thumbnail.jpg',
  'Saint Louis University': '/TopCollegeProfileTHUMBNAILS/SLU_Thumbnail.jpg',
  'Texas Christian University': '/TopCollegeProfileTHUMBNAILS/TCU_Thumbnail.jpg',
  'Brigham Young University': '/TopCollegeProfileTHUMBNAILS/BYU_Thumbnail.jpg',
  'California State University–Long Beach': '/TopCollegeProfileTHUMBNAILS/CalStateLongBeach_Thumbnail.jpg',
  'California State University–Fullerton': '/TopCollegeProfileTHUMBNAILS/CalStateFullerton_Thumbnail.jpg',
  'George Mason University': '/TopCollegeProfileTHUMBNAILS/GeogeMason_Thumbnail.jpg',
  'Arizona State University': '/TopCollegeProfileTHUMBNAILS/ASU_Thumbnail.jpg',
  'Chapman University': '/TopCollegeProfileTHUMBNAILS/Chapman_Thumbnail.jpg',
  'Creighton University': '/TopCollegeProfileTHUMBNAILS/Creighton_Thumbnail.jpg',
  'CUNY—City College': '/TopCollegeProfileTHUMBNAILS/CUNYCityCollege_Thumbnail.jpg',
  'Elon University': '/TopCollegeProfileTHUMBNAILS/Elon_Thumbnail.jpg',
  'Iowa State University of Science and Technology': '/TopCollegeProfileTHUMBNAILS/IowaState_Thumbnail.jpg',
  'University of Central Florida': '/TopCollegeProfileTHUMBNAILS/UCFlorida_Thumbnail.jpg',
  'Clark University': '/TopCollegeProfileTHUMBNAILS/ClarkUniversity_Thumbnail.jpg',
  'Fairfield University': '/TopCollegeProfileTHUMBNAILS/FairfieldUniversity_Thumbnail.jpg',
  'Loyola University Chicago': '/TopCollegeProfileTHUMBNAILS/Loyola_Thumbnail.jpg',
  'Miami University—Oxford': '/TopCollegeProfileTHUMBNAILS/MiamiUniversityOxford_Thumbnail.jpg',
  'Thomas Jefferson University': '/TopCollegeProfileTHUMBNAILS/ThomasJeffersonUniversity_Thumbnail.jpg',
  'SUNY College of Environmental Science and Forestry': '/TopCollegeProfileTHUMBNAILS/SUNYEnvironmentalScience_Thumbnail.jpg',
  'University of Minnesota Twin Cities': '/TopCollegeProfileTHUMBNAILS/UMinnTwinCitiesThumbnail.jpg',
  'College of William & Mary': '/TopCollegeProfileTHUMBNAILS/WilliamANDMaryThumbnail.jpg',
  'Northeastern University': '/TopCollegeProfileTHUMBNAILS/NortheasternUniversityThumbnail.jpg',
  'Florida State University': '/TopCollegeProfileTHUMBNAILS/FloridaStateUniversityThumbnail.jpg',
  // --- Fallback Image ---
  'Default': '/harvard.jpg'
};

// --- Header Images ---
// Using the same thumbnail images for headers as well
const headerImageMap = {
  'Harvard University': '/harvard.jpg',
  'Stanford University': '/TopCollegeProfileTHUMBNAILS/StanfordThumbnail.jpg',
  'Massachusetts Institute of Technology': '/mit_institution.jpg',
  'Princeton University': '/TopCollegeProfileTHUMBNAILS/PrincetonThumbnail.jpg',
  'Yale University': '/TopCollegeProfileTHUMBNAILS/YaleThumbnail.jpg',
  'University of Chicago': '/TopCollegeProfileTHUMBNAILS/UChicagoThumbnail.jpg',
  'University of Pennsylvania': '/TopCollegeProfileTHUMBNAILS/UPennThumbnail.jpg',
  'California Institute of Technology': '/TopCollegeProfileTHUMBNAILS/CaltechThumbnail.jpg',
  'Duke University': '/TopCollegeProfileTHUMBNAILS/DukeThumbnail.jpg',
  'Johns Hopkins University': '/TopCollegeProfileTHUMBNAILS/JohnsHopkinsThumbnail.jpg',
  'Northwestern University': '/TopCollegeProfileTHUMBNAILS/NorthwesternThumbnail.jpg',
  'Cornell University': '/TopCollegeProfileTHUMBNAILS/CornellThumbnail.jpg',
  'Brown University': '/TopCollegeProfileTHUMBNAILS/BrownThumbnail.jpg',
  'Columbia University': '/TopCollegeProfileTHUMBNAILS/ColumbiaThumbnail.jpg',
  'Dartmouth College': '/TopCollegeProfileTHUMBNAILS/DartmouthThumbnail.jpg',
  'Vanderbilt University': '/TopCollegeProfileTHUMBNAILS/VanderbuiltThumbnail.jpg',
  'Rice University': '/TopCollegeProfileTHUMBNAILS/RiceThumbnail.jpg',
  'University of California, Los Angeles': '/TopCollegeProfileTHUMBNAILS/UCLAThumbnail.jpg',
  'University of California, Berkeley': '/TopCollegeProfileTHUMBNAILS/UCBerkeleyThumbnail.jpg',
  'New York University': '/TopCollegeProfileTHUMBNAILS/NYUThumbnail.jpg',
  'University of Southern California': '/TopCollegeProfileTHUMBNAILS/USCThumbnail.jpg',
  'Carnegie Mellon University': '/TopCollegeProfileTHUMBNAILS/CMUThumbnail.jpg',
  'University of Notre Dame': '/TopCollegeProfileTHUMBNAILS/NotreDameThumbnail.jpg',
  'Georgetown University': '/TopCollegeProfileTHUMBNAILS/GeorgetownThumbnail.jpg',
  'Emory University': '/TopCollegeProfileTHUMBNAILS/EmoryThumbnail.jpg',
  'University of Michigan–Ann Arbor': '/TopCollegeProfileTHUMBNAILS/UMichThumbnail.jpg',
  'University of Virginia': '/TopCollegeProfileTHUMBNAILS/UVAThumbnail.jpg',
  'Wake Forest University': '/TopCollegeProfileTHUMBNAILS/WF_Thumbnail.jpg',
  'University of Florida': '/TopCollegeProfileTHUMBNAILS/UoFloridaThumbnail.jpg',
  'University of North Carolina–Chapel Hill': '/TopCollegeProfileTHUMBNAILS/UNCThumbnail.jpg',
  'Tufts University': '/TopCollegeProfileTHUMBNAILS/TuftsThumbnail.jpg',
  'University of California, Santa Barbara': '/TopCollegeProfileTHUMBNAILS/UCSBThumbnail.jpg',
  'University of California, San Diego': '/TopCollegeProfileTHUMBNAILS/UCSDThumbnail.jpg',
  'University of California, Irvine': '/TopCollegeProfileTHUMBNAILS/UCIrvineThumbnail.jpg',
  'University of California, Davis': '/TopCollegeProfileTHUMBNAILS/UCDavisThumbnail.jpg',
  'University of California, Santa Cruz': '/TopCollegeProfileTHUMBNAILS/UCSantaCruz_Thumbnail.jpg',
  'University of California, Merced': '/TopCollegeProfileTHUMBNAILS/UCMerced_Thumbnail.jpg',
  'University of California, Riverside': '/TopCollegeProfileTHUMBNAILS/UCRiverside_Thumbnail.jpg',
  'Boston College': '/TopCollegeProfileTHUMBNAILS/BostonCollegeThumbnail.jpg',
  'Boston University': '/TopCollegeProfileTHUMBNAILS/BostonUniversityThumbnail.jpg',
  'Georgia Institute of Technology': '/TopCollegeProfileTHUMBNAILS/GTechThumbnail.jpg',
  'University of Texas at Austin': '/TopCollegeProfileTHUMBNAILS/UTAustinThumbnail.jpg',
  'The University of Texas–Dallas': '/TopCollegeProfileTHUMBNAILS/UTDallas_Thumbnail.jpg',
  'University of Washington': '/TopCollegeProfileTHUMBNAILS/UW_Thumbnail.jpg',
  'University of Wisconsin-Madison': '/TopCollegeProfileTHUMBNAILS/UWMadison.jpg',
  'University of Illinois Urbana-Champaign': '/TopCollegeProfileTHUMBNAILS/UIUCThumbnail.jpg',
  'University of Illinois Chicago': '/TopCollegeProfileTHUMBNAILS/UIC_Thumbnail.jpg',
  'Ohio State University': '/TopCollegeProfileTHUMBNAILS/Ohio-State-UniversityTHUMBNAIL.jpg',
  'Purdue University': '/TopCollegeProfileTHUMBNAILS/PurdueThumbnail.jpg',
  'Texas A&M University': '/TopCollegeProfileTHUMBNAILS/TAMU_Thumbnail.jpg',
  'Rutgers University': '/TopCollegeProfileTHUMBNAILS/RutgersThumbnail.jpg',
  'Rutgers University–Newark': '/TopCollegeProfileTHUMBNAILS/RutgersNewark_Thumbnail.jpg',
  'University of Maryland': '/TopCollegeProfileTHUMBNAILS/UMDCollegeParkThumbnail.jpg',
  'University of Maryland, Baltimore County': '/TopCollegeProfileTHUMBNAILS/UniversityofMarylandBaltimore_Thumbnail.jpg',
  'University of Rochester': '/TopCollegeProfileTHUMBNAILS/URochesterThumbnail.jpg',
  'Case Western Reserve University': '/TopCollegeProfileTHUMBNAILS/CaseWesternThumbnail.jpg',
  'Lehigh University': '/TopCollegeProfileTHUMBNAILS/LehighThumbnail.jpg',
  'Virginia Tech': '/TopCollegeProfileTHUMBNAILS/VTech_Thumbnail.jpg',
  'Virginia Commonwealth University': '/TopCollegeProfileTHUMBNAILS/VirginiaCommonwealth_Thumbnail.jpg',
  'Washington University in St. Louis': '/TopCollegeProfileTHUMBNAILS/WashUThumbnail.jpg',
  'University of Georgia': '/TopCollegeProfileTHUMBNAILS/UGA_Thumbnail.jpg',
  'University of Miami': '/TopCollegeProfileTHUMBNAILS/UMiami_Thumbnail.jpg',
  'University of Massachusetts Amherst': '/TopCollegeProfileTHUMBNAILS/UMassAmherst_Thumbnail.jpg',
  'North Carolina State University': '/TopCollegeProfileTHUMBNAILS/NCSU_Thumbnail.jpg',
  'Michigan State University': '/TopCollegeProfileTHUMBNAILS/MichiganState_Thumbnail.jpg',
  'The Pennsylvania State University–University Park': '/TopCollegeProfileTHUMBNAILS/PennState_Thumbnail.jpg',
  'Stony Brook University (SUNY)': '/TopCollegeProfileTHUMBNAILS/StonyBrook_Thumbnail.jpg',
  'University at Buffalo (SUNY)': '/TopCollegeProfileTHUMBNAILS/SUNYBuffalo_Thumbnail.jpg',
  'University at Albany (SUNY)': '/TopCollegeProfileTHUMBNAILS/SUNYAlbany_Thumbnail.jpg',
  'Santa Clara University': '/TopCollegeProfileTHUMBNAILS/SantaClara_Thumbnail.jpg',
  'Tulane University of Louisiana': '/TopCollegeProfileTHUMBNAILS/Tulane_Thumbnail.jpg',
  'Villanova University': '/TopCollegeProfileTHUMBNAILS/Villanova_Thumbnail.jpg',
  'Brandeis University': '/TopCollegeProfileTHUMBNAILS/Brandheis_Thumbnail.jpg',
  'George Washington University': '/TopCollegeProfileTHUMBNAILS/GeorgeWashingtonU_Thumbnail.jpg',
  'San Diego State University': '/TopCollegeProfileTHUMBNAILS/SDState_Thumbnail.jpg',
  'University of Arizona': '/TopCollegeProfileTHUMBNAILS/UniversityofArizona_Thumbnail.jpg',
  'University of Missouri': '/TopCollegeProfileTHUMBNAILS/UniversityofMizzou_Thumbnail.jpg',
  'University of New Hampshire': '/TopCollegeProfileTHUMBNAILS/UniversityofNewHampshire_Thumbnail.jpg',
  'University of Oregon': '/TopCollegeProfileTHUMBNAILS/UniversityofOregon_Thumbnail.jpg',
  'Oregon State University': '/TopCollegeProfileTHUMBNAILS/OregonState_Thumbnail.jpg',
  'University of San Diego': '/TopCollegeProfileTHUMBNAILS/UniversityofSanDiego_Thumbnail.jpg',
  'University of San Francisco': '/TopCollegeProfileTHUMBNAILS/UniversityofSanFrancisco_Thumbnail.jpg',
  'University of Tennessee–Knoxville': '/TopCollegeProfileTHUMBNAILS/UniversityofTennesseeKnoxville_Thumbnail.jpg',
  'University of Delaware': '/TopCollegeProfileTHUMBNAILS/UniversityofDelaware_Thumbnail.jpg',
  'University of Denver': '/TopCollegeProfileTHUMBNAILS/UniversityofDenver_Thumbnail.jpg',
  'University of South Carolina': '/TopCollegeProfileTHUMBNAILS/UniversityofSouthCarolina_Thumbnail.jpg',
  'University of Vermont': '/TopCollegeProfileTHUMBNAILS/UniversityofVermont_Thumbnail.jpg',
  'University of Utah': '/TopCollegeProfileTHUMBNAILS/UniversityofUtah_Thumbnail.jpg',
  'University of Houston': '/TopCollegeProfileTHUMBNAILS/UniversityofHouston_Thumbnail.jpg',
  'The University of Oklahoma': '/TopCollegeProfileTHUMBNAILS/UniversityofOklahoma_Thumbnail.jpg',
  'University of Alabama at Birmingham': '/TopCollegeProfileTHUMBNAILS/AlabamaBirmigham_Thumbnail.jpg',
  'University of Dayton': '/TopCollegeProfileTHUMBNAILS/UniversityofDayton_Thumbnail.jpg',
  'University of the Pacific': '/TopCollegeProfileTHUMBNAILS/UniversityofthePacific_Thumbnail.jpg',
  'Drexel University': '/TopCollegeProfileTHUMBNAILS/Drexel_Thumbnail.jpg',
  'Rensselaer Polytechnic Institute': '/TopCollegeProfileTHUMBNAILS/Rensselaer_Thumbnail.jpg',
  'Stevens Institute of Technology': '/TopCollegeProfileTHUMBNAILS/Stevens_Thumbnail.jpg',
  'New Jersey Institute of Technology': '/TopCollegeProfileTHUMBNAILS/NJIT_Thumbnail.jpg',
  'University of Connecticut': '/TopCollegeProfileTHUMBNAILS/UConn_Thumbnail.jpg',
  'University of Pittsburgh': '/TopCollegeProfileTHUMBNAILS/UPitt_Thumbnail.jpg',
  'Binghamton University (SUNY)': '/TopCollegeProfileTHUMBNAILS/BinghamtonSUNY_Thumbnail.jpg',
  'Indiana University–Bloomington': '/TopCollegeProfileTHUMBNAILS/IUBloomington_Thumbnail.jpg',
  'Syracuse University': '/TopCollegeProfileTHUMBNAILS/SyracuseUniversity_Thumbnail.jpg',
  'Colorado School of Mines': '/TopCollegeProfileTHUMBNAILS/ColoradoSchoolofMines_Thumbnail.jpg',
  'Pepperdine University': '/TopCollegeProfileTHUMBNAILS/Pepperdine_Thumbnail.jpg',
  'Howard University': '/TopCollegeProfileTHUMBNAILS/Howard_Thumbnail.jpg',
  'Marquette University': '/TopCollegeProfileTHUMBNAILS/Marquette_Thumbnail.jpg',
  'Auburn University': '/TopCollegeProfileTHUMBNAILS/Auburn_Thumbnail.jpg',
  'Illinois Institute of Technology': '/TopCollegeProfileTHUMBNAILS/IllinoisIT_Thumbnail.jpg',
  'Saint Louis University': '/TopCollegeProfileTHUMBNAILS/SLU_Thumbnail.jpg',
  'Texas Christian University': '/TopCollegeProfileTHUMBNAILS/TCU_Thumbnail.jpg',
  'Brigham Young University': '/TopCollegeProfileTHUMBNAILS/BYU_Thumbnail.jpg',
  'California State University–Long Beach': '/TopCollegeProfileTHUMBNAILS/CalStateLongBeach_Thumbnail.jpg',
  'California State University–Fullerton': '/TopCollegeProfileTHUMBNAILS/CalStateFullerton_Thumbnail.jpg',
  'George Mason University': '/TopCollegeProfileTHUMBNAILS/GeogeMason_Thumbnail.jpg',
  'Arizona State University': '/TopCollegeProfileTHUMBNAILS/ASU_Thumbnail.jpg',
  'Chapman University': '/TopCollegeProfileTHUMBNAILS/Chapman_Thumbnail.jpg',
  'Creighton University': '/TopCollegeProfileTHUMBNAILS/Creighton_Thumbnail.jpg',
  'CUNY—City College': '/TopCollegeProfileTHUMBNAILS/CUNYCityCollege_Thumbnail.jpg',
  'Elon University': '/TopCollegeProfileTHUMBNAILS/Elon_Thumbnail.jpg',
  'Iowa State University of Science and Technology': '/TopCollegeProfileTHUMBNAILS/IowaState_Thumbnail.jpg',
  'University of Central Florida': '/TopCollegeProfileTHUMBNAILS/UCFlorida_Thumbnail.jpg',
  'Clark University': '/TopCollegeProfileTHUMBNAILS/ClarkUniversity_Thumbnail.jpg',
  'Fairfield University': '/TopCollegeProfileTHUMBNAILS/FairfieldUniversity_Thumbnail.jpg',
  'Loyola University Chicago': '/TopCollegeProfileTHUMBNAILS/Loyola_Thumbnail.jpg',
  'Miami University—Oxford': '/TopCollegeProfileTHUMBNAILS/MiamiUniversityOxford_Thumbnail.jpg',
  'Thomas Jefferson University': '/TopCollegeProfileTHUMBNAILS/ThomasJeffersonUniversity_Thumbnail.jpg',
  'SUNY College of Environmental Science and Forestry': '/TopCollegeProfileTHUMBNAILS/SUNYEnvironmentalScience_Thumbnail.jpg',
  'University of Minnesota Twin Cities': '/TopCollegeProfileTHUMBNAILS/UMinnTwinCitiesThumbnail.jpg',
  'College of William & Mary': '/TopCollegeProfileTHUMBNAILS/WilliamANDMaryThumbnail.jpg',
  'Northeastern University': '/TopCollegeProfileTHUMBNAILS/NortheasternUniversityThumbnail.jpg',
  'Florida State University': '/TopCollegeProfileTHUMBNAILS/FloridaStateUniversityThumbnail.jpg',
  // --- Fallback Image ---
  'Default': '/harvard.jpg'
};

// --- Nickname/Abbreviation Map ---
const nicknameMap = {
  'MIT': 'Massachusetts Institute of Technology',
  'UMich': 'University of Michigan–Ann Arbor',
  'UCLA': 'University of California, Los Angeles',
  'UC Berkeley': 'University of California, Berkeley',
  'Caltech': 'California Institute of Technology',
  'USC': 'University of Southern California',
  'NYU': 'New York University',
  'UW': 'University of Washington',
  'UT Austin': 'University of Texas at Austin',
  'UIUC': 'University of Illinois Urbana-Champaign',
  'UMass Amherst': 'University of Massachusetts Amherst',
  'Penn State': 'The Pennsylvania State University–University Park',
  'WashU': 'Washington University in St. Louis',
  'UCSD': 'University of California, San Diego',
  'UCSB': 'University of California, Santa Barbara',
  'UCI': 'University of California, Irvine',
  'UCD': 'University of California, Davis',
  'UCR': 'University of California, Riverside',
  'UCSF': 'University of California, San Francisco',
  'UCSantaCruz': 'University of California, Santa Cruz',
  'UCMerced': 'University of California, Merced',
  'UMN': 'University of Minnesota Twin Cities',
  'FSU': 'Florida State University',
  'Northeastern': 'Northeastern University',
  'William & Mary': 'College of William & Mary',
  'SLU': 'Saint Louis University',
  'TCU': 'Texas Christian University',
  'TAMU': 'Texas A&M University',
  'BYU': 'Brigham Young University',
  'RPI': 'Rensselaer Polytechnic Institute',
  'NJIT': 'New Jersey Institute of Technology',
  'UIC': 'University of Illinois Chicago',
  'SUNY Albany': 'University at Albany (SUNY)',
  'SUNY Buffalo': 'University at Buffalo (SUNY)',
  'Stony Brook': 'Stony Brook University (SUNY)',
  'Binghamton': 'Binghamton University (SUNY)',
  'NCSU': 'North Carolina State University',
  'UMiami': 'University of Miami',
  'UMinn': 'University of Minnesota Twin Cities',
  'UC Davis': 'University of California, Davis',
  'UC Irvine': 'University of California, Irvine',
  'UC Santa Cruz': 'University of California, Santa Cruz',
  'UC Merced': 'University of California, Merced',
  'UC Riverside': 'University of California, Riverside',
  'UC San Diego': 'University of California, San Diego',
  'UC Santa Barbara': 'University of California, Santa Barbara',
  'UC Los Angeles': 'University of California, Los Angeles',
  'UVA': 'University of Virginia',
  'UMD': 'University of Maryland',
  'UMass': 'University of Massachusetts Amherst',
  'UConn': 'University of Connecticut',
  'UChicago': 'University of Chicago',
  'CMU': 'Carnegie Mellon University',
  'Cal Poly': 'California Polytechnic State University',
  'Cal State Fullerton': 'California State University–Fullerton',
  'Cal State Long Beach': 'California State University–Long Beach',
  'Pepperdine': 'Pepperdine University',
  'Marquette': 'Marquette University',
  'Howard': 'Howard University',
  'Drexel': 'Drexel University',
  'Stevens': 'Stevens Institute of Technology',
  'Lehigh': 'Lehigh University',
  'Fairfield': 'Fairfield University',
  'Clark': 'Clark University',
  'Loyola': 'Loyola University Chicago',
  'Miami University': 'Miami University—Oxford',
  'Thomas Jefferson': 'Thomas Jefferson University',
  'Elon': 'Elon University',
  'Chapman': 'Chapman University',
  'Creighton': 'Creighton University',
  'Case Western': 'Case Western Reserve University',
  'Brandeis': 'Brandeis University',
  'Tulane': 'Tulane University of Louisiana',
  'Santa Clara': 'Santa Clara University',
  'Villanova': 'Villanova University',
  'George Washington': 'George Washington University',
  'George Mason': 'George Mason University',
  'Indiana University': 'Indiana University–Bloomington',
  'Syracuse': 'Syracuse University',
  'Colorado School of Mines': 'Colorado School of Mines',
  'Oregon State': 'Oregon State University',
  'University of Oregon': 'University of Oregon',
  'University of Arizona': 'University of Arizona',
  'University of Missouri': 'University of Missouri',
  'University of New Hampshire': 'University of New Hampshire',
  'University of Delaware': 'University of Delaware',
  'University of Denver': 'University of Denver',
  'University of South Carolina': 'University of South Carolina',
  'University of Vermont': 'University of Vermont',
  'University of Utah': 'University of Utah',
  'University of Houston': 'University of Houston',
  'University of Oklahoma': 'The University of Oklahoma',
  'University of Alabama at Birmingham': 'University of Alabama at Birmingham',
  'University of Dayton': 'University of Dayton',
  'University of the Pacific': 'University of the Pacific',
  'SUNY Environmental Science': 'SUNY College of Environmental Science and Forestry',
};

// --- Helper: Normalize string for matching ---
function normalize(str) {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
}

// --- Helper: Get all available image file names (without extension) ---
const availableThumbnails = [
  // List of all files in public/TopCollegeProfileTHUMBNAILS/ (without extension)
  'UMinnTwinCitiesThumbnail',
  'NortheasternUniversityThumbnail',
  'WilliamANDMaryThumbnail',
  'FloridaStateUniversityThumbnail',
  'BostonUniversityThumbnail',
  'SUNYAlbany_Thumbnail',
  'UCFlorida_Thumbnail',
  'UniversityofDenver_Thumbnail',
  'UniversityofSouthCarolina_Thumbnail',
  'UniversityofVermont_Thumbnail',
  'ClarkUniversity_Thumbnail',
  'FairfieldUniversity_Thumbnail',
  'Loyola_Thumbnail',
  'UniversityofOklahoma_Thumbnail',
  'CalStateFullerton_Thumbnail',
  'MiamiUniversityOxford_Thumbnail',
  'ThomasJeffersonUniversity_Thumbnail',
  'AlabamaBirmigham_Thumbnail',
  'UniversityofDayton_Thumbnail',
  'UniversityofthePacific_Thumbnail',
  'UniversityofUtah_Thumbnail',
  'VirginiaCommonwealth_Thumbnail',
  'OregonState_Thumbnail',
  'SUNYEnvironmentalScience_Thumbnail',
  'UniversityofHouston_Thumbnail',
  'UniversityofMarylandBaltimore_Thumbnail',
  'ColumbiaThumbnail',
  'StanfordThumbnail',
  'YaleThumbnail',
  'WashUThumbnail',
  'WF_Thumbnail',
  'Villanova_Thumbnail',
  'VanderbuiltThumbnail',
  'VTech_Thumbnail',
  'UoFloridaThumbnail',
  'UniversityofTennesseeKnoxville_Thumbnail',
  'UniversityofSanFrancisco_Thumbnail',
  'UniversityofSanDiego_Thumbnail',
  'UniversityofOregon_Thumbnail',
  'UniversityofNewHampshire_Thumbnail',
  'UniversityofMizzou_Thumbnail',
  'UniversityofDelaware_Thumbnail',
  'UniversityofArizona_Thumbnail',
  'UW_Thumbnail',
  'UWMadison',
  'UVAThumbnail',
  'UTDallas_Thumbnail',
  'UTAustinThumbnail',
  'USCThumbnail',
  'URochesterThumbnail',
  'UPitt_Thumbnail',
  'UPennThumbnail',
  'UNCThumbnail',
  'UMichThumbnail',
  'UMiami_Thumbnail',
  'UMassAmherst_Thumbnail',
  'UMDCollegeParkThumbnail',
  'UIUCThumbnail',
  'UIC_Thumbnail',
  'UGA_Thumbnail',
  'UConn_Thumbnail',
  'UChicagoThumbnail',
  'UCSantaCruz_Thumbnail',
  'UCSDThumbnail',
  'UCSBThumbnail',
  'UCRiverside_Thumbnail',
  'UCMerced_Thumbnail',
  'UCLAThumbnail',
  'UCIrvineThumbnail',
  'UCDavisThumbnail',
  'UCBerkeleyThumbnail',
  'Tulane_Thumbnail',
  'TuftsThumbnail',
  'TCU_Thumbnail',
  'TAMU_Thumbnail',
  'SyracuseUniversity_Thumbnail',
  'StonyBrook_Thumbnail',
  'Stevens_Thumbnail',
  'SantaClara_Thumbnail',
  'SUNYBuffalo_Thumbnail',
  'SLU_Thumbnail',
  'SDState_Thumbnail',
  'RutgersThumbnail',
  'RutgersNewark_Thumbnail',
  'RiceThumbnail',
  'Rensselaer_Thumbnail',
  'PurdueThumbnail',
  'PrincetonThumbnail',
  'Pepperdine_Thumbnail',
  'PennState_Thumbnail',
  'Ohio-State-UniversityTHUMBNAIL',
  'NotreDameThumbnail',
  'NorthwesternThumbnail',
  'NYUThumbnail',
  'NJIT_Thumbnail',
  'NCSU_Thumbnail',
  'MichiganState_Thumbnail',
  'Marquette_Thumbnail',
  'MITThumbnail',
  'LehighThumbnail',
  'JohnsHopkinsThumbnail',
  'Howard_Thumbnail',
  'HarvardThumbnail',
  'GeorgetownThumbnail',
  'GeorgeWashingtonU_Thumbnail',
  'GeogeMason_Thumbnail',
  'FloridaStateUniversityThumbnail',
  'Elon_Thumbnail',
  'DukeThumbnail',
  'Drexel_Thumbnail',
  'CreightonUniversityThumbnail',
  'CornellThumbnail',
  'ColumbiaThumbnail',
  'ColoradoSchoolofMines_Thumbnail',
  'CMUThumbnail',
  'CaltechThumbnail',
  'CalStateLongBeach_Thumbnail',
  'CalStateFullerton_Thumbnail',
  'BYU_Thumbnail',
  'Brandheis_Thumbnail',
  'BostonUniversityThumbnail',
  'BostonCollegeThumbnail',
  'BinghamtonSUNY_Thumbnail',
  'ASU_Thumbnail',
  'ArizonaStateUniversity_Thumbnail',
  'Auburn_Thumbnail',
  'AlabamaBirmigham_Thumbnail',
  'ASU_Thumbnail',
  'Chapman_Thumbnail',
  'ClarkUniversity_Thumbnail',
  'FairfieldUniversity_Thumbnail',
  'GTechThumbnail',
  'IllinoisIT_Thumbnail',
  'IUBloomington_Thumbnail',
  'IowaState_Thumbnail',
  'Loyola_Thumbnail',
  'MiamiUniversityOxford_Thumbnail',
  'NJIT_Thumbnail',
  'NortheasternUniversityThumbnail',
  'OregonState_Thumbnail',
  'PrincetonThumbnail',
  'RiceThumbnail',
  'SLU_Thumbnail',
  'StanfordThumbnail',
  'Stevens_Thumbnail',
  'TCU_Thumbnail',
  'Tulane_Thumbnail',
  'UMassAmherst_Thumbnail',
  'UMDCollegeParkThumbnail',
  'UMiami_Thumbnail',
  'UMichThumbnail',
  'UMinnTwinCitiesThumbnail',
  'UNCThumbnail',
  'UPennThumbnail',
  'URochesterThumbnail',
  'USCThumbnail',
  'UTAustinThumbnail',
  'UTDallas_Thumbnail',
  'UVAThumbnail',
  'UWMadison',
  'UW_Thumbnail',
  'VTech_Thumbnail',
  'VanderbuiltThumbnail',
  'Villanova_Thumbnail',
  'VirginiaCommonwealth_Thumbnail',
  'WashUThumbnail',
  'WF_Thumbnail',
  'WilliamANDMaryThumbnail',
];

// --- Helper: Try multiple image formats ---
export const getImageWithFallback = (collegeName) => {
  const primaryPath = getThumbnail(collegeName);
  
  // If the primary path is already in our map, return it
  if (thumbnailMap[collegeName]) {
    return primaryPath;
  }
  
  // For fuzzy matches, try multiple extensions
  const baseName = primaryPath.replace('/TopCollegeProfileTHUMBNAILS/', '').replace(/\.[^/.]+$/, '');
  const extensions = ['.jpg', '.jpeg'];
  
  // Return the primary path first, let the component handle fallbacks
  return primaryPath;
};

// --- Helper: Get all supported image formats for a college ---
export const getAllImageFormats = (collegeName) => {
  try {
    const primaryPath = getThumbnail(collegeName);
    
    // If we have a direct match in the thumbnailMap, return just that path
    if (thumbnailMap[collegeName]) {
      return [primaryPath];
    }
    
    // Extract base name from the path
    const baseName = primaryPath.replace('/TopCollegeProfileTHUMBNAILS/', '').replace(/\.[^/.]+$/, '');
    
    // If baseName is empty or invalid, return the primary path
    if (!baseName || baseName === primaryPath) {
      return [primaryPath];
    }
    
    const extensions = ['.jpg', '.jpeg'];
    
    return extensions.map(ext => `/TopCollegeProfileTHUMBNAILS/${baseName}${ext}`);
  } catch (error) {
    // Fallback to default image if anything goes wrong
    return ['/harvard.jpg'];
  }
};

// --- Main: Smart thumbnail getter ---
export const getThumbnail = (collegeName) => {
  // 1. Direct map
  if (thumbnailMap[collegeName]) return thumbnailMap[collegeName];

  // 2. Nickname/abbreviation
  if (nicknameMap[collegeName] && thumbnailMap[nicknameMap[collegeName]]) {
    return thumbnailMap[nicknameMap[collegeName]];
  }

  // 3. Fuzzy match: normalize and compare to availableThumbnails
  const normName = normalize(collegeName);
  
  // Try direct normalized match
  let found = availableThumbnails.find(file => {
    const cleanFile = file.replace('Thumbnail', '').replace('_Thumbnail', '');
    const normFile = normalize(cleanFile);
    return normName.includes(normFile) || normFile.includes(normName);
  });
  
  if (found) {
    // Check if the found thumbnail exists in the thumbnailMap with any extension
    const baseName = found.replace('Thumbnail', '').replace('_Thumbnail', '');
    
    // First, try to find an exact match in the thumbnailMap
    for (const [college, path] of Object.entries(thumbnailMap)) {
      if (normalize(college).includes(normalize(baseName)) || normalize(baseName).includes(normalize(college))) {
        return path;
      }
    }
    
    // If no exact match found, try common extensions
    const extensions = ['.jpg', '.jpeg'];
    for (const ext of extensions) {
      const path = `/TopCollegeProfileTHUMBNAILS/${found}${ext}`;
      // Note: In a real implementation, you might want to check if the file actually exists
      // For now, we'll return the path and let the browser handle 404s
      return path;
    }
  }

  // 4. Try normalized nickname
  if (nicknameMap[collegeName]) {
    const normNick = normalize(nicknameMap[collegeName]);
    found = availableThumbnails.find(file => {
      const cleanFile = file.replace('Thumbnail', '').replace('_Thumbnail', '');
      const normFile = normalize(cleanFile);
      return normNick.includes(normFile) || normFile.includes(normNick);
    });
    
    if (found) {
      // Check if the found thumbnail exists in the thumbnailMap
      const baseName = found.replace('Thumbnail', '').replace('_Thumbnail', '');
      
      for (const [college, path] of Object.entries(thumbnailMap)) {
        if (normalize(college).includes(normalize(baseName)) || normalize(baseName).includes(normalize(college))) {
          return path;
        }
      }
      
      // If no exact match found, try common extensions
      const extensions = ['.jpg', '.jpeg'];
      for (const ext of extensions) {
        const path = `/TopCollegeProfileTHUMBNAILS/${found}${ext}`;
        return path;
      }
    }
  }

  // 5. Fallback
  return thumbnailMap['Default'];
};

export const getHeaderImage = (collegeName) => headerImageMap[collegeName] || headerImageMap['Default'];